/* eslint-disable max-statements */
(function($) {
  'use strict';

  var $inPageNav = $('.inpage-nav'),
    $factListing = $('.fact-listing');

  /**
   * Animate a smooth scroll to a particular element
   * @param {jQuery} $element
   */
  function scrollToElement($element) {
    var scrollPosition = $element.offset().top - $inPageNav.outerHeight() - 50;

    $('html, body')
      .stop()
      .animate(
        {
          scrollTop: scrollPosition,
        },
        500,
        'swing'
      );
  }

  if ($inPageNav.length && $factListing.length) {
    $factListing.find('a[href^="#"]').on('click', function(e) {
      e.preventDefault();
      var href = $(this).attr('href');
      if (href !== '#') {
        var $target = $(href);
        scrollToElement($target);
      }
    });
  }
}(jQuery));
